import axios from './axios'
import { API_BASE_URL } from 'src/constants'

// Fetches current analysis stats (used by pie/radar charts and should be used by summary)
export const getCurrentStats = async () => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/analysis-stats/history/`)
    return data
  } catch (error) {
    console.error('Error fetching current stats:', error)
    throw error
  }
}

// Fetches trend stats for a given number of days (used by column chart)
export const getAnalysisStats = async (days) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/analysis-stats/trend/`, {
      params: { days },
    })
    return data
  } catch (error) {
    console.error('Error fetching analysis stats:', error)
    throw error
  }
}
